import { A } from "@solidjs/router"
import slugify from "slugify"
import { Component, Show, For } from "solid-js"
import { Exhibiting } from "./exhibiting"
import { RawHtml } from "./raw-html"
import { Img } from "./universal/image"
import { ArtworkItem, NewImage } from "../Types"

type Props = {
    model: ArtworkItem;
}

type OtherImagesProps = {
    images: NewImage[];
}
const OtherImages : Component<OtherImagesProps> = ({ images }) => {
    return (
        <div>
            <For each={images}>{(image) => 
                <div class="image-row" style={{ width: "500px" }}>
                    <a href={"/Common/Image?imageId=" + image.Id}>
                        <Img
                            class="no-clicky-for-you"
                            src={image.URL}
                            mode="fit" maxWidth={500} naturalHeight={image.Height} naturalWidth={image.Width}
                        />
                            <span class="fa fa-search magnify"></span>
                        </a>
                    </div>
            }</For>
        </div>        
    )
}

export const Artwork: Component<Props> = ({ model }) => {
    return (
        <div style="background-color: #333; padding: 20px; height: 100%;">
            <div class="row">
                <div class="col-md-6">
                    <div id="left-container" class="pull-right">
                        <div style="position: relative;">
                            <a href={"/Salon/Common/Image?imageId=" + model.Image.Id} style="text-align: center; outline: none;">
                                <Img
                                    class="no-clicky-for-you"
                                    src={model.Image.URL}
                                    mode="fit" maxWidth={700} naturalHeight={model.Image.Height} naturalWidth={model.Image.Width}
                                    style={{ "outline": "none", "width": "100%" }}
                                />
                            </a>
                            <span class="fa fa-search magnify"></span>
                        </div>
                        <Show when={model.OtherImages}>
                            <Show when={model.OtherImagesRowPosition == "UnderPrimaryImage"}>
                                <div class="row under-primary-image pull-right">
                                    <div class="col-md-12">
                                        <OtherImages images={model.OtherImages} />
                                    </div>
                                </div>
                            </Show>
                        </Show>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="grid-item" style="max-width: none; width: 100%;">
                        <div id="right-container" class="didactic">
                            <p class="artist">
                                <A href={`/artist/${slugify(model.Artist)}/${model.ContestEntrantId}`}>
                                    {model.Artist}
                                </A>
                            </p>
                            <p class="title">
                                {model.Title}
                            </p>
                            <Show when={model.Year}>
                                <p style="font-size: 1.75em;">
                                    {model.Year}
                                </p>
                            </Show>
                            <Show when={model.Measurements}>
                                <p class="measurements" innerHTML={model.Measurements}></p>
                            </Show>
                            <p>
                                {model.Medium}
                            </p>
                            <Show when={model.Awards?.length}>
                                <div>
                                    <label class="header">
                                        Awards
                                    </label>
                                    <ul class="list-inline">
                                        <For each={model.Awards}>{(award) =>
                                            <li style="margin-bottom: 5px;">
                                                <span style="font-family: 'Bariol-Regular'; font-size: 1em;" class="label label-default label-award">
                                                    {award.Category} - {award.Award}
                                                    <Show when={award.Amount}><span style="margin-left: 10px;">(${award.Amount})</span></Show>
                                                </span>
                                            </li>
                                        }</For>
                                    </ul>
                                </div>
                            </Show>
                            <Exhibiting artwork={model} />
                            <Show when={model.School}>
                                <hr />
                                <Show when={model.Teacher}>
                                    <p>
                                        <b>Taught by:</b> {model.Teacher}
                                    </p>
                                </Show>
                                <Show when={model.School}>
                                    <p>
                                        <b>Studied at:</b> {model.School}
                                    </p>
                                </Show>
                            </Show>
                            <Show when={model.Awards && model.Comment}>
                                <div class="comment">
                                    <RawHtml value={model.Comment} />
                                </div>
                            </Show>
                        </div>
                    </div>
                    <Show when={model.OtherImages}>
                        <Show when={model.OtherImagesRowPosition == null || model.OtherImagesRowPosition == "UnderDidactic"}>
                            <OtherImages images={model.OtherImages} />
                        </Show>
                    </Show>
                </div>
            </div>
        </div>
    )
}